import { render, staticRenderFns } from "./process_j.vue?vue&type=template&id=35212d78&scoped=true"
import script from "./process_j.vue?vue&type=script&lang=js"
export * from "./process_j.vue?vue&type=script&lang=js"
import style0 from "./process_j.vue?vue&type=style&index=0&id=35212d78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35212d78",
  null
  
)

export default component.exports